import React, { Component } from "react"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import { CallbackComponent } from "redux-oidc"
import userManager from "../../utils/user-manager"

class Callback extends Component {
  // This will be called on a standard login. We may not want to
  // use this but leaving it here for now.
  // If the result was successful we should redirect to home page.
  // If not we should redirect to a warning page.
  successCallback = () => {
    // redirect to main page.
  }
  errorCallback = () => {
    // redirect to a page showing an error message.
  }
  render() {
    return (
      <CallbackComponent
        children={<div>Boom</div>}
        userManager={userManager}
        successCallback={this.successCallback}
        errorCallback={this.successCallback}
      />
    )
  }
}
export default compose(translate(), connect())(Callback)



// WEBPACK FOOTER //
// ./src/routes/auth/Callback.jsx